import {Component, inject} from '@angular/core';
import {UserHasCausableAdminAccessDirective} from "../../../directives/permissions/user-has-causable-admin-access.directive";
import {AgGridAngular} from "ag-grid-angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatCard} from "@angular/material/card";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatTooltip} from "@angular/material/tooltip";
import {PlayersService} from "../../../services/players.service";
import {PhoneFormatPipe} from "../../../pipes/phone-format.pipe";
import {Router} from "@angular/router";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {IPlayerSearchParams} from "../../../interfaces/player/IPlayerSearchParams";
import {BasePlayerSearchComponent} from "../base-search.component";
import {GameService} from "../../../services/game.service";
import {ContainerComponent} from "@coreui/angular";
import {
  TableExportButtonsComponent
} from "../../../components/table-export-buttons/table-export-buttons.component";

@Component({
  selector: 'app-global-game-search',
  standalone: true,
  imports: [
    UserHasCausableAdminAccessDirective,
    AgGridAngular,
    FormsModule,
    MatButton,
    MatCard,
    MatError,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatTooltip,
    ReactiveFormsModule,
    ContainerComponent,
    TableExportButtonsComponent
  ],
  templateUrl: '../player-search-page.html',
  styleUrl: './global-player-search.component.css'
})
export class GlobalPlayerSearchComponent extends BasePlayerSearchComponent {
  private gameService: GameService = inject(GameService);

  constructor(
    playerService: PlayersService,
    phoneFormatPipe: PhoneFormatPipe,
    errorHandlingService: ErrorHandlingService,
    router: Router
  ) {
    super(playerService, phoneFormatPipe, errorHandlingService, router);
    this.gameService.clearActiveGame();
  }

  protected getSearchParams(): IPlayerSearchParams | undefined {
    return {
      email: this.playerSearchForm.controls.email.value || '',
      lastName: this.playerSearchForm.controls.lastName.value || '',
      firstName: this.playerSearchForm.controls.firstName.value || '',
      phoneNumber: this.playerService.stripPhoneFormatting(this.phoneNumberControl.value),
      playerId: this.playerSearchForm.controls.playerId.value || '',
      maskData: true
    };
  }

  protected isGlobalSearch(): boolean {
    return true;
  }

  protected exportScopeLabel(): string {
    return 'All games';
  }

  protected exportFileNameScope(): (string | null | undefined)[] {
    return ['all-games'];
  }

  protected exportTestIdPrefix(): string {
    return 'global-player-search';
  }

  protected getPlayerManagementUrl(playerId: string): string {
    return `/manage-player/${playerId}`;
  }
}
